import { BrandSortOrder } from 'types/graphql'

export type SortOrderOption = {
  key: BrandSortOrder
  label: string
  paramName: string
}

/**
 * Maps params to enum keys for queries, but also defines what options should show in the order
 * popover, in which order, and with what label.
 */
export const SORT_OPTIONS: SortOrderOption[] = [
  { key: BrandSortOrder.Recommended, label: 'Default', paramName: 'recommended' },
  // { key: BrandSortOrder.LastReviewed, label: 'Last Reviewed', paramName: 'lastReviewed' },
  // { key: BrandSortOrder.MostReviewed, label: 'Most Reviewed', paramName: 'mostReviewed' },
  { key: BrandSortOrder.Added, label: 'Latest', paramName: 'added' }
  // { key: BrandSortOrder.Launched, label: 'Date Launched', paramName: 'launched' },
  // { key: BrandSortOrder.AtoZ, label: 'A > Z', paramName: 'a-z' }
]

export const DEFAULT_SORT_OPTION = SORT_OPTIONS[0]

export const getSortOption = (key: BrandSortOrder): SortOrderOption => {
  const option = SORT_OPTIONS.find((possible) => possible.key === key)
  if (option) {
    return option
  } else {
    throw new Error('Unknown sort order option')
  }
}

export const paramToSortOrder = (param: string, fallbackOptionKey: BrandSortOrder): SortOrderOption => {
  const optionFromParam = SORT_OPTIONS.find((possible) => possible.paramName === param)
  return optionFromParam || getSortOption(fallbackOptionKey)
}
